// Client-side file limits. The authoritative validation lives in Ruby
// (the upload controllers); these keep the picker from uploading files the
// server would reject anyway.
export const MAX_MEDIA_SIZE = 30 * 1024 * 1024; // 30MB for media (photos/videos)

const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

export const ALLOWED_VIDEO_TYPES = [
  'video/mp4',
  'video/quicktime',
  'video/webm',
];

export const ALLOWED_MEDIA_TYPES = [
  ...ALLOWED_IMAGE_TYPES,
  ...ALLOWED_VIDEO_TYPES,
];
